document.addEventListener('DOMContentLoaded', function () {
  // Select elements with error checking
  const triggerButton = document.getElementById('custom_BIS_trigger');
  const overlay = document.querySelector('.waitlist-modal-overlay');
  const waitlistModal = document.querySelector('.waitlist-modal');
  const closeButton = document.querySelector('.waitlist-close');
  const waitlistForm = document.querySelector('.waitlist-form');
  const submitButton = document.querySelector('.waitlist-submit');
  const completedMessage = document.querySelector('.completed_message');
  // Check if critical elements exist
  if (!triggerButton) {
    //console.error('Error: Element with id="custom_BIS_trigger" not found.');
    return;
  }
  const loadingSpinner = triggerButton.querySelector('.loading-overlay__spinner');
  if (!loadingSpinner) {
    console.error('Error: .loading-overlay__spinner not found inside triggerButton.');
  }
  if (!completedMessage) {
    console.error('Error: .completed_message not found.');
  }

  // Button click handler for "Join the Waitlist"
  if (triggerButton) {
    triggerButton.addEventListener('click', function () {
      const variantId = this.getAttribute('data-variant-id'); // 51840139297134
      //console.log('Button clicked, variantId:', variantId);

      // Set aria-hidden="true" on the loading spinner
      if (loadingSpinner) {
        loadingSpinner.setAttribute('aria-hidden', 'true');
      }

      // Show custom modal
      if (waitlistModal && overlay) {
        waitlistModal.setAttribute('aria-hidden', 'false');
        overlay.classList.add('overlayActive');
      } else {
        //console.error('Cannot show modal: waitlistModal or overlay not found.');
        alert('Unable to show waitlist form. Please try again later.');
      }
    });
  }

  // Form submission handler for "NOTIFY ME" button
  if (waitlistForm && submitButton) {
    waitlistForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const emailInput = waitlistForm.querySelector('.waitlist-input');
      if (!emailInput) {
        //.error('Error: .waitlist-input not found.');
        return;
      }
      const email = emailInput.value.trim();
      const variantId = triggerButton.getAttribute('data-variant-id'); // 51840139297134
      const productId = triggerButton.getAttribute('data-product-id'); // Use provided productId
      const shop = 'maison-de-sabre-jap.myshopify.com'; // Confirmed Shopify domain

      if (!email) {
        //console.error('Error: Email input is empty.');
        const alert = waitlistForm.querySelector('.waitlist-error-alert');
        if (alert) {
          alert.textContent = 'Please specify an email address';
          alert.style.display = 'block';
        }
        return;
      }

      if (!productId) {
        //console.error('Error: productId is missing or invalid.');
        const alert = waitlistForm.querySelector('.waitlist-error-alert');
        if (alert) {
          alert.textContent = 'Product configuration error. Please contact support.';
          alert.style.display = 'block';
        }
        return;
      }

      // Prepare API request URL
      const params = new URLSearchParams({
        'shop': shop,
        'notification[email]': email,
        'notification[product_no]': productId,
        'notification[quantity_required]': '1',
        'notification[accepts_marketing]': 'true',
        'notification[customer_utc_offset]': '19800', // IST (+5:30)
        'variant[variant_no]': variantId
      });
      const apiUrl = `https://app.backinstock.org/stock_notification/create.json?${params.toString()}`;
      //console.log('Submitting GET request to:', apiUrl);

      // Show loading spinner
      if (loadingSpinner) {
        loadingSpinner.setAttribute('aria-hidden', 'false');
      }

      fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          //console.log('API response:', data);
          if (loadingSpinner) {
            loadingSpinner.setAttribute('aria-hidden', 'true');
          }
          if (data.status === 'OK') {
            // Show success message
            if (completedMessage) {
              completedMessage.style.display = 'block';
            }
            // Close modal and reset form after 2 seconds
            setTimeout(() => {
              if (waitlistModal && overlay) {
                waitlistModal.setAttribute('aria-hidden', 'true');
                overlay.classList.remove('overlayActive');
              }
              emailInput.value = '';
              const alert = waitlistForm.querySelector('.waitlist-error-alert');
              if (alert) alert.style.display = 'none';
              // Hide success message
              if (completedMessage) {
                completedMessage.style.display = 'none';
              }
            }, 2000);
          } else {
            const alert = waitlistForm.querySelector('.waitlist-error-alert');
            if (alert) {
              alert.textContent = data.errors?.email?.join() || data.errors.base || 'Failed to subscribe. Please try again.';
              alert.style.display = 'block';
            }
          }
        })
        .catch(error => {
          //console.error('Error calling API:', error);
          if (loadingSpinner) {
            loadingSpinner.setAttribute('aria-hidden', 'true');
          }
          // Fallback: Log email for manual import
          //console.log('Fallback: Email collected:', email, 'for variant:', variantId, 'product:', productId);
          alert('Email recorded. We’ll notify you when available.');
          if (waitlistModal && overlay) {
            waitlistModal.setAttribute('aria-hidden', 'true');
            overlay.classList.remove('overlayActive');
          }
          emailInput.value = '';
          const alert = waitlistForm.querySelector('.waitlist-error-alert');
          if (alert) alert.style.display = 'none';
        });
    });
  } else {
    console.error('Error: .waitlist-form or .waitlist-submit not found.');
  }

  // Overlay click handler
  if (overlay) {
    overlay.addEventListener('click', function () {
      //console.log('Overlay clicked');
      if (loadingSpinner) {
        loadingSpinner.setAttribute('aria-hidden', 'true');
      }
      if (waitlistModal) {
        waitlistModal.setAttribute('aria-hidden', 'true');
        overlay.classList.remove('overlayActive');
      }
      const alert = waitlistForm?.querySelector('.waitlist-error-alert');
      if (alert) alert.style.display = 'none';
      if (completedMessage) completedMessage.style.display = 'none';
    });
  } else {
  }

  // Close button handler
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      //console.log('Close button clicked');
      if (loadingSpinner) {
        loadingSpinner.setAttribute('aria-hidden', 'true');
      }
      if (waitlistModal && overlay) {
        waitlistModal.setAttribute('aria-hidden', 'true');
        overlay.classList.remove('overlayActive');
      }
      const alert = waitlistForm?.querySelector('.waitlist-error-alert');
      if (alert) alert.style.display = 'none';
      if (completedMessage) completedMessage.style.display = 'none';
    });
  } else {
    console.error('Error: .waitlist-close not found.');
  }
});